<section>
  <div class="modal-content">
    <div class="modal-header bg-primary">
      <h5 class="m-0 me-2 text-white">Activate</h5>
      <button type="button" class="close" (click)="modalService.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">

        <lord-icon src="https://cdn.lordicon.com/hjeefwhm.json" trigger="loop" colors="primary:#1473b3"
          style="width:100px;height:100px"></lord-icon>
        <div class="mt-1 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you sure ?</h4>
          <p class="text-muted">Are you sure you want to Activate this '{{title}}' ?</p>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light mr-1" data-bs-dismiss="modal"
          (click)="modalService.close()">Cancel
        </button>
        <button type="button" class="btn w-sm btn-primary" id="delete-product" (click)="confirm()">Confirm
        </button>
      </div>
    </div>
  </div>
</section>